export default function Finish({onComplete}) {
  return (
    <div className="finish-container">
    <div onClick={onComplete} className="finish-indicator">
      <span className="finish">Finish!</span>
    </div>
    </div>
    
  )
}